import { memo } from 'react';
import { Chip, Typography } from '@mui/material';
import { useAuditScoreColor } from 'modules/audit/management/hooks/useAuditScoreColor';
import { ServiceType } from 'modules/settings/templates/main/interfaces';
import { useTranslation } from 'react-i18next';
import { formatNumber } from 'utils/math';

type Props = {
  value?: string;
  score?: number;
  serviceType?: ServiceType;
  transNs?: string;
};
type StyleMap = Record<string, { backgroundColor: string; color: string }>;

// // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
const STYLES: StyleMap = {
  COMPLETED: { backgroundColor: '#10756930', color: '#107569' },
  APPROVED: { backgroundColor: '#32427550', color: '#293F83' },
  DRAFT: { backgroundColor: '#FDF2CE', color: '#d99a1f' },
  PLANNING: { backgroundColor: '#FDF2CE', color: '#d99a1f' },
  IN_PROGRESS: { backgroundColor: '#E0E4FF', color: '#3C50E0' },
};

export const AuditStatusChipLabel = ({ value, score, serviceType }: Props) => {
  const color = useAuditScoreColor(score, serviceType);

  return (
    <>
      <span className='uppercase'>{value}</span>{' '}
      {score ? (
        <>
          <span className={'text-[0.60rem] font-light text-gray-400'}>|</span>{' '}
          <Typography color={color} component={'span'} className={'text-[0.80rem]'}>
            {formatNumber(score)} %
          </Typography>
        </>
      ) : null}
    </>
  );
};

const AuditStatusChip = ({ value, score, serviceType, transNs = 'audit' }: Props) => {
  const { t } = useTranslation(transNs);

  return (
    <Chip
      label={
        <AuditStatusChipLabel value={t(`statusName.${value as string}`)} score={score} serviceType={serviceType} />
      }
      sx={{ px: 1, py: 2, minWidth: '140px', ...STYLES[value as string] }}
    />
  );
};

export default memo(AuditStatusChip);
